type CookieOptions = { expires?: Date; path?: string; domain?: string; secure?: boolean; samesite?: string };

export const setCookie = (name: string, value: string, options: CookieOptions) => {
  const parts = [`${name}=${value}`];

  if (options.expires) parts.push(`expires=${options.expires.toUTCString()}`);
  if (options.path) parts.push(`path=${options.path}`);
  if (options.domain) parts.push(`domain=${options.domain}`);
  if (options.secure) parts.push(`secure`);
  if (options.samesite) parts.push(`samesite=${options.samesite}`);

  document.cookie = parts.join('; ');
};
